<div fxLayout="column" fxLayoutAlign="start start" class="margin-bottom-1rem">
    <div class="forge-typography--heading2">
        {{group}}
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="start start" class="group-keys">
        <forge-label-value *ngFor="let shortcut of shortcuts">
            <span slot="label">{{shortcut.Keys}}</span>
            <span slot="value">{{shortcut.Description}}</span>
        </forge-label-value>
    </div>
</div>
